<template>
  <v-app id="inspire">
    <sidebar-admin
      v-if="userProfileDetails.webrole == 'admin'"
      @logout="logout"
      v-model="drawer"
    />
    <sidebar-user
      v-else-if="userProfileDetails.webrole == 'user'"
      @logout="logout"
      v-model="drawer"
    />

    <v-app-bar app clipped-left class="">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Wiedemann Lampe | {{ currentProject }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link :to="`/users/reset`">
        <v-btn>Reset</v-btn>
      </router-link>
      <v-btn icon class="mr-4" @click="logout">Logout</v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <span class="small">&copy; Wiedemann Lampe 2023</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
const fb = require("./firebaseConfig.js");
import { SidebarAdmin, SidebarUser } from "@/components/core";
// import Navigation from './components/Navigation.vue'

export default {
  components: { SidebarAdmin, SidebarUser },
  computed: {
    ...mapState([
      "currentUser",
      "userProfileDetails",
      "currentProject",
      "currentExercises",
    ]),
  },
  data() {
    return {
      drawer: false,
    };
  },
  created() {
    this.$vuetify.theme.dark = true;
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import "./styles/app";
</style>
